<template>
    <header>
        <div class="container d-flex justify-content-between">
            <router-link :to="{name: 'homepage'}" class="align-middle">
                <img class="logo" src="../media/logo_crop.png" alt="UNTRR">
            </router-link>
            <div class='navbar-wrapper d-flex'>
                <template v-if="!loginStatus">
                    <div class="icon profile-icon mr-4" @click="toogleContMenu()"></div>
                </template>

                <template v-if="loginStatus">
                    <router-link :to="{name: 'account-data'}">
                        <div class="icon profile-icon mr-4"></div>
                    </router-link>
                </template>

                <router-link :to="{name: 'cart'}" class="mr-4">
                   <div class="shopping-cart">
                        <div class="badge-count" v-if="cartCount() > 0">
                            {{cartCount()}}
                        </div>
                        <div class="icon cart-icon"></div>
                    </div>
                </router-link>

                <div class="icon hamburger-icon" @click="toogleSideMenu()"></div>
            </div>
        </div>
        <ContMenu></ContMenu>
        <SideMenu></SideMenu>
    </header>
</template>

<script>
import SideMenu from './snippets/SideMenu.vue';
import ContMenu from './snippets/ContMenu.vue';
import Language from './snippets/Language.vue';
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'Header',
    components: {
        Language,
        ContMenu,
        SideMenu
    },
    computed: {
        ...mapGetters({
            loginStatus: 'auth/getLoginStatus'
        })
    },
    props: {
    },
    methods: {
        ...mapGetters('cart', [
            'cartCount'
        ]),

        ...mapActions('menu', [
            'toogleSideMenu',

        ]),

        ...mapActions('cont', [
            'toogleContMenu',
        ]),
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$lightgrey: lightgrey;
$green: #59af54;
$white-yellow: #FAF9F6;
$black: #000;

header {
    background-color: $white-yellow;
    height: 60px;
    color: $black;
    display: flex;
    align-items: center;
    z-index:1040;
    position: fixed;
    width: 100%;
    animation-name: example;
    animation-duration: 1s;

    a {
        color: $black;
    }

    &.no-border {
        border-bottom: none;
    }
    .logo{
        width: 72px;
        height: 32px;
    }
}

.navbar-wrapper{
    align-items: center;
}

a {

    text-decoration: none;

    &:visited {
        color: white;
    }

    &:hover {
        color: white;
    }

    &:active {
        color: white;
    }
}

.hamburger {
    display: inline-block;
    vertical-align: middle;
    padding-top:5px;
    margin-right: 5px;
}

.home-title {

    display: inline-block;

    img {
        max-height: 30px;
    }
    a:link {
        color: black;
        text-decoration: none;
    }

    /* visited link */
    a:visited {
        color: black;
        text-decoration: none;
    }

    /* mouse over link */
    a:hover {
        color: black;
        text-decoration: none;
    }

    /* selected link */
    a:active {
        color: black;
        text-decoration: none;
    }
}


.nav-icons {
    padding: 11px 0px 11px 0px;

    a {
        display: inline-block;
        vertical-align: middle;
    }

    a:link {
        color: white;
        text-decoration: none;
    }
    /* visited link */
    a:visited {
        color: white;
        text-decoration: none;
    }
    /* mouse over link */
    a:hover {
        color: white;
        text-decoration: none;
    }
    /* selected link */
    a:active {
        color: white;
        text-decoration: none;
    }
    .dropdown {
        display: inline-block;

        .dropdown-menu {
            position: absolute;
            z-index: 10;
            padding: 0;

            a {
                color: black;
            }
        }
        .dropdown-item {
            border-bottom-color: $lightgrey;
            border-bottom-style: solid;
            border-bottom-width: 1px;
            padding: 8px 20px;
        }
    }

    .languages {
        display: inline-block;
        position: relative;
        vertical-align: middle;
        font-size: 12px;

        .dropdown-menu {

            .dropdown-item {
                color: black;

                &.active {
                    color: white;
                }
            }
        }
    }
}


.fa-bars:before {
    font-size: 20px;
    padding: 5px;
}

.fa-shopping-cart:before {
    font-size: 20px;
    padding: 5px;
}

.fa-user-circle:before {
    font-size: 20px;
    padding: 5px;
}

.cart-icon {
    position: relative;

    .badge-count {
        position: absolute;
        background: #F23E5C;
        color: white;
        border-radius: 50%;
        font-size: 11px;
        right: -3px;
        top: -5px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 1;
        padding: 7px;
        width: 15px;
        height: 15px;
    }
}

</style>
